<template>
    <div
        class="bg-black opacity-40 bg-no-repeat bg-cover bg-center absolute inset-0 z-0"
        :style="{ backgroundImage: `url(${bgLobby})` }"
    >
    </div>
</template>

<script>
export default {
    name: 'BgGlobal',
    props: [ 'bgLobby' ]
}
</script>
